module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-home.component.html
// module id = ../../../../../src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-home.component.html
// module chunks = main